var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customers" },
    [
      _c("RouterView"),
      _c("div", { staticClass: "box customers-list wrapper-customers" }, [
        _c("div", { staticClass: "title-container is-flex" }, [
          _c(
            "h2",
            { staticClass: "title is-3 has-text-primary title-customers" },
            [_vm._v("\n        Mis clientes\n      ")]
          ),
          _c("div", { staticClass: "buttons" }, [
            _c("div", { staticClass: "field is-grouped" }, [
              _c(
                "p",
                { staticClass: "control" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "button is-primary btn-add-customer",
                      on: { click: _vm.openModal }
                    },
                    [
                      _c("BIcon", { attrs: { icon: "plus" } }),
                      _c("span", [
                        _vm._v(
                          "\n                Nuevo cliente\n              "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "p",
                { staticClass: "control" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "button is-illuminating-emerald btn-bulk-upload",
                      attrs: { to: { name: "CustomerBulkUpload" } }
                    },
                    [
                      _c("BIcon", { attrs: { icon: "cloud-upload-outline" } }),
                      _c("span", [
                        _vm._v("\n                Carga masiva\n              ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c("BTable", {
              attrs: {
                data: _vm.$store.state.customers.list,
                loading: _vm.$store.state.customers.loading,
                total: _vm.$store.state.customers.count,
                "current-page": _vm.page,
                columns: _vm.columns,
                "per-page": _vm.size,
                "backend-pagination": "",
                paginated: ""
              },
              on: { "page-change": _vm.changePage },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(props) {
                    return [
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "companyName",
                            label: "Nombre de la empresa",
                            internal: ""
                          }
                        },
                        [
                          _c(
                            "RouterLink",
                            {
                              staticClass: "action-option",
                              attrs: {
                                to: {
                                  name: "CustomerEdit",
                                  params: { customer: props.row.id }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.companyName) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "BTableColumn",
                        { attrs: { field: "rfc", label: "RFC", internal: "" } },
                        [
                          _c(
                            "RouterLink",
                            {
                              staticClass: "action-option",
                              attrs: {
                                to: {
                                  name: "CustomerEdit",
                                  params: { customer: props.row.id }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.rfc) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "email",
                            label: "Contacto",
                            internal: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.row.email) +
                              "\n          "
                          )
                        ]
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "totalDebt",
                            label: "Deuda total",
                            internal: ""
                          }
                        },
                        _vm._l(props.row.debtsCustomer, function(debt, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("toCurrency")(
                                    debt.totalAmount,
                                    debt._id.currency
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "totalDebtExpired",
                            label: "Deuda vencida",
                            internal: ""
                          }
                        },
                        _vm._l(props.row.debtsExpired, function(debt, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "has-text-danger" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      debt.totalAmount,
                                      debt._id.currency
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: {
                            field: "availableCredit",
                            label: "Crédito disponible",
                            internal: ""
                          }
                        },
                        [
                          props.row.creditLimit > 0
                            ? _vm._l(props.row.debtCreditLimit, function(
                                debt,
                                index
                              ) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          props.row.creditLimit -
                                            debt.totalAmount,
                                          debt.currency
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ])
                              })
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "BTableColumn",
                        {
                          attrs: { field: "controls", label: "", internal: "" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "is-flex is-centered" },
                            [
                              _c(
                                "BTooltip",
                                {
                                  attrs: {
                                    label: props.row.accStatusToken
                                      ? "Con Edo de Cuenta"
                                      : "Sin Edo de Cuenta",
                                    position: "is-left"
                                  }
                                },
                                [
                                  props.row.accStatusToken
                                    ? _c("BIcon", {
                                        attrs: {
                                          icon: "file-check",
                                          type: "is-success"
                                        }
                                      })
                                    : _vm._e(),
                                  !props.row.accStatusToken
                                    ? _c("BIcon", {
                                        attrs: {
                                          icon: "file-cancel",
                                          type: "is-danger"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "AppRadialMenu",
                                {
                                  attrs: {
                                    size: 36,
                                    "item-size": 48,
                                    radius: 80,
                                    "angle-restriction": 140,
                                    rotate: -80
                                  }
                                },
                                [
                                  _c(
                                    "AppRadialMenuItem",
                                    {
                                      class: _vm.deleteClass,
                                      attrs: { "data-tooltip": "Eliminar" }
                                    },
                                    [
                                      _c(
                                        "RouterLink",
                                        {
                                          staticClass: "action-option",
                                          attrs: {
                                            to: {
                                              name: "CustomerDelete",
                                              params: { customer: props.row.id }
                                            }
                                          }
                                        },
                                        [
                                          _c("BIcon", {
                                            staticClass: "action-option-icon",
                                            attrs: { icon: "delete" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "AppRadialMenuItem",
                                    {
                                      class: _vm.editClass,
                                      attrs: { "data-tooltip": "Editar" }
                                    },
                                    [
                                      _c(
                                        "RouterLink",
                                        {
                                          staticClass: "action-option",
                                          attrs: {
                                            to: {
                                              name: "CustomerEdit",
                                              params: { customer: props.row.id }
                                            }
                                          }
                                        },
                                        [
                                          _c("BIcon", {
                                            staticClass: "action-option-icon",
                                            attrs: { icon: "pencil" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "AppRadialMenuItem",
                                    {
                                      staticClass:
                                        "tooltip is-tooltip-danger has-background-danger has-text-white",
                                      attrs: {
                                        "data-tooltip":
                                          "Remover estado de cuenta"
                                      }
                                    },
                                    [
                                      _c(
                                        "RouterLink",
                                        {
                                          staticClass: "action-option",
                                          attrs: {
                                            to: {
                                              name: "StatusAccountDelete",
                                              params: {
                                                customer: props.row.id,
                                                company: props.row.companyId
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c("BIcon", {
                                            staticClass: "action-option-icon",
                                            attrs: { icon: "cancel" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "AppRadialMenuItem",
                                    {
                                      staticClass:
                                        "tooltip is-tooltip-success has-background-success has-text-white",
                                      attrs: {
                                        "data-tooltip":
                                          "Enviar estado de cuenta"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "action-option",
                                          on: {
                                            click: function($event) {
                                              return _vm.sendStatusAccountEmail(
                                                props.row.id,
                                                props.row.companyId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("BIcon", {
                                            staticClass: "action-option-icon",
                                            attrs: { icon: "send" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "AppRadialMenuItem",
                                    {
                                      class: _vm.commentClass,
                                      attrs: { "data-tooltip": "Conversar" }
                                    },
                                    [
                                      _c(
                                        "RouterLink",
                                        {
                                          staticClass: "action-option",
                                          attrs: {
                                            to: {
                                              name: "CustomerChat",
                                              params: {
                                                customer: props.row.id,
                                                company: props.row.companyId
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c("BIcon", {
                                            staticClass: "action-option-icon",
                                            attrs: { icon: "comment" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }